import { render, staticRenderFns } from "./EPFSetupEdit.vue?vue&type=template&id=1694a587"
import script from "./EPFSetupEdit.vue?vue&type=script&lang=js"
export * from "./EPFSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports